import { useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "./auth/authSlice"; 

const IdleTimerControl = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // Use the exact path you used in ProtectedRoute
  const isAuthenticated = useSelector((state) => state.authSlice.isAuthenticated);
  const timerRef = useRef(null);

  // Memoize logout function so it doesn't change on re-renders
  const handleLogout = useCallback(async () => {
    try {
      await dispatch(logout());
      navigate("/home");
      alert("You have been logged out due to inactivity.");
    } catch (error) {
      console.error("Auto-logout failed:", error);
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    // Only set listeners if the user is actually logged in
    if (!isAuthenticated) return;

    const ONE_HOUR = 60 * 60 * 1000;

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(handleLogout, ONE_HOUR);
    };


    const events = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    // Initial timer start
    resetTimer();

    // Cleanup: Remove listeners and clear timer when user logs out or leaves
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [isAuthenticated, handleLogout]); 

  return null;
};

export default IdleTimerControl;